export function initials(name?: string | null, max = 2): string {
  // Use only letter/digit-leading words so malformed names (RMP imports like
  // "(Cynthia) Cyndi Rickards" or ". Formicola") don't yield "(C" / ".F" avatars.
  const n = (name ?? '').trim();
  if (!n) return '?';
  const parts = n
    .split(/\s+/)
    .map((w) => w.replace(/^[^\p{L}\p{N}]+/u, ''))
    .filter(Boolean);
  if (!parts.length) return '?';
  const raw = parts.length >= 2 ? parts[0][0] + parts[1][0] : parts[0][0];
  return raw.toUpperCase().slice(0, max);
}
